import { useTheme } from '@material-ui/core/styles';
import SvgIcon from '@material-ui/core/SvgIcon';
import React from 'react';

export default function LineIcon({ ...props }) {
  const theme = useTheme();

  return (
    <SvgIcon width="1182" height="16" viewBox="0 0 1182 16" {...props}>
      <rect opacity="0.3" y="8" width="1182" height="2" fill="white" />
      <circle
        cx="126"
        cy="8"
        r="7"
        fill={theme.palette.primary.main}
        stroke="white"
        strokeWidth="2"
      />
      <circle
        cx="438"
        cy="8"
        r="7"
        fill={theme.palette.primary.main}
        stroke="white"
        strokeWidth="2"
      />
      <circle
        cx="750"
        cy="8"
        r="7"
        fill={theme.palette.primary.main}
        stroke="white"
        strokeWidth="2"
      />
      <circle
        cx="1062"
        cy="8"
        r="7"
        fill={theme.palette.primary.main}
        stroke="white"
        strokeWidth="2"
      />
    </SvgIcon>
  );
}
